import { ScaleFilterTypes } from '~src/interfaces/scale.interface';
import { FilterI } from '~src/shared/lists/listFilters/ListFilters';

import { ScaleTypeIcons, scaleTypes } from './scaleTypes';

export interface ScalesFilter extends FilterI {
  id: ScaleFilterTypes;
  iconName?: ScaleTypeIcons;
  viewBoxWidth?: number;
}

export const filterOptions: ScalesFilter[] = [
  {
    id: 'all',
    labelKey: 'x.scales.list.filters.all',
  },
  ...scaleTypes.map((item) => ({
    id: item.value,
    labelKey: item.name,
    iconName: item.iconName,
    tooltipKey: item.description,
    itemsAmount: 0,
    disabled: true,
    viewBoxWidth: item.viewBoxWidth,
  })),
];
